(function (w, d, $, undefined) {
  /* ================================
   * Slider Component
   * ================================ */
  console.log('tiptoe:: Slider-instagram');

  $(w).on('load', function () {
    const $instagram = $('.instagram__images');
    if ($instagram) {
      $instagram.flickity({
        cellAlign: 'left',
        contain: true,
        wrapAround: false,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
      });
    }
  });
})(window, document, jQuery);
